// slices/match.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import axios from '../../utils/axios';
import { AppThunk } from '../store.types';

interface MatchState {
  isLoading: boolean;
  error: string | null;
  tickets: any[];
}

const initialState: MatchState = {
  isLoading: false,
  error: null,
  tickets: [],
};

const slice = createSlice({
  name: 'ticket',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getTicketsSuccess(state, action: PayloadAction<any[]>) {
      state.isLoading = false;
      state.tickets = action.payload;
    },
  },
});

export const { startLoading, hasError, getTicketsSuccess } = slice.actions;

export default slice.reducer;

export const getTickets = (): AppThunk => async (dispatch) => {
  dispatch(startLoading());
  try {
    const response = await axios.get(`/api/v1/client/tickets`);
    dispatch(getTicketsSuccess(response.data));
  } catch (error) {
    dispatch(hasError(error.toString()));
  }
};

export const getTicket = async (keyId: any) => {
  const response = await axios.get(`/api/v1/client/ticket-id/${keyId}/`);
  return response.data;
};
